import { Grid, TextField } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@mui/material";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
function UpdateImg() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [img, setImg] = useState("");
  const [img1, setImg1] = useState("");
  const [img2, setImg2] = useState("");

  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/staff/${id}`
      )
      .then((res) => {
        setImg([res.data.images.personal_photo]);
        setImg1([res.data.images.id_photo1]);
        setImg2([res.data.images.id_photo2]);
      })
      .catch((err) => {});
  }, []);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImage2, setSelectedImage2] = useState("");
  const [selectedImage3, setSelectedImage3] = useState("");
  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage(e.target.files[0]);
    }
  };
  const imageChange2 = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage2(e.target.files[0]);
    }
  };
  const imageChange3 = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      setSelectedImage3(e.target.files[0]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const bodyFormData = new FormData();
    if (selectedImage2.length != 0) {
      bodyFormData.append("id_photo1", selectedImage2);
    } else {
    }

    if (selectedImage3.length != 0) {
      bodyFormData.append("id_photo2", selectedImage3);
    } else {
    }
    if (selectedImage.length != 0) {
      bodyFormData.append("personal_photo", selectedImage);
    } else {
    }

    axios
      .post(
        `${BaseUrl}/api/staff/update-image/staff-id/${id}`,
        bodyFormData
      )
      .then((res) => {
        if (res.status === 200) {
          sweetalert("تم التعديل بنجاح");
          navigate("/staff");
        } else {
          sweetalert("error");
        }
      });
  };

  return (
    <div className="main-div">
      <h3 className="titlepage">تعديل صور المستخدم</h3>

      <form
        method="post"
        enctype="multipart/form-data"
        noValidate
        onSubmit={handleSubmit}
      >
        <Grid
          container
          spacing={4}
          item
          lg={12}
          md={12}
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            height: "200px",
            marginBottom: "40px",
            alignItems: "center",
          }}
        >
          <Grid item md={6} xs={6}>
            <TextField
              placeholder=""
              className="form-control"
              label=""
              name="personal_photo"
              fullWidth
              required
              type="file"
              onChange={imageChange}
            />
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            xs={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
            {selectedImage ? (
              <div className="box_img_update">
                            
                <img src={URL.createObjectURL(selectedImage)} alt="Thumb" />
              </div>
            ) : (
              <div className="box_img_update">
                <img src={img} />
              </div>
            )}
                 
          </Grid>
        </Grid>
        <Grid
          container
          spacing={4}
          item
          lg={12}
          md={12}
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            height: "200px",
            marginBottom: "40px",
            alignItems: "center",
          }}
        >
          <Grid item md={6} xs={6}>
            <TextField
              placeholder=""
              className="form-control"
              label=""
              name="id_photo1"
              fullWidth
              required
              type="file"
              onChange={imageChange2}
            />
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            xs={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
             
            {selectedImage2 ? (
              <div className="box_img_update">
                            
                <img src={URL.createObjectURL(selectedImage2)} alt="Thumb" />
              </div>
            ) : (
              <div className="box_img_update">
                <img src={img1} alt="image_id_1" />
              </div>
            )}
                 
          </Grid>
        </Grid>
        <Grid
          container
          spacing={4}
          item
          lg={12}
          md={12}
          xs={12}
          style={{
            display: "flex",
            justifyContent: "center",
            height: "200px",
            alignItems: "center",
          }}
        >
          <Grid item md={6} xs={6}>
            <TextField
              placeholder=""
              className="form-control"
              label=""
              name="id_photo2"
              fullWidth
              required
              type="file"
              onChange={imageChange3}
            />
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            xs={6}
            style={{ display: "flex", justifyContent: "center" }}
          >
             
            {selectedImage3 ? (
              <div className="box_img_update">
                            
                <img src={URL.createObjectURL(selectedImage3)} alt="Thumb" />
              </div>
            ) : (
              <div className="box_img_update">
                <img src={img2} alt="image_id_2" />
              </div>
            )}
                   
          </Grid>
        </Grid>
        <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
          <Button
            type="submit"
            variant="contained"
            className="btn-submit"
            color="secondary"
          >
            حفظ
          </Button>
          <Button
            onClick={() => {
              navigate(`/viewstaff/${id}`);
            }}
            variant="contained"
            className="btn-submit"
            color="secondary"
          >
            الغاء
          </Button>
        </Grid>
      </form>
    </div>
  );
}

export default UpdateImg;
